import "./RoboticsCourseHP2.module.css";
import Header from "@/reusable_sections/Header";
import RoboticsCourseOverview from "./sections/RoboticsCourseOverview";
import Footer from "@/reusable_sections/Footer";
export default function RoboticsCourseHP2Page() {
  return <div>
      <Header />
      <RoboticsCourseOverview />
      <Footer />
    </div>;
}